/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imagesremovedonsave3Inputs */

const en_imagesremovedonsave3 = /** @type {(inputs: Imagesremovedonsave3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The old picture is removed when you save.`)
};

const de_imagesremovedonsave3 = /** @type {(inputs: Imagesremovedonsave3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das alte Bild wird beim Speichern entfernt.`)
};

/**
* | output |
* | --- |
* | "The old picture is removed when you save." |
*
* @param {Imagesremovedonsave3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imagesremovedonsave3 = /** @type {((inputs?: Imagesremovedonsave3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imagesremovedonsave3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imagesremovedonsave3(inputs)
	return de_imagesremovedonsave3(inputs)
});
export { imagesremovedonsave3 as "imagesRemovedOnSave" }